import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationActionTypes } from '../../models/actions.enum';

@Pipe({
    name: 'appActionButtonTitle',
    standalone: false
})
export class AppActionButtonTitlePipe implements PipeTransform {
    transform(applicationAction: ApplicationActionTypes, applicationName: string): string | undefined {
        const launchTitle = 'Click to launch this app';
        const comingSoonTitle = `Coming soon: ${applicationName}`;
        const learnMoreTitle = 'Click to find out how to access this app';

        const matcher: { [key in ApplicationActionTypes]: string } = {
            [ApplicationActionTypes.Launch]: launchTitle,
            [ApplicationActionTypes.ComingSoon]: comingSoonTitle,
            [ApplicationActionTypes.LearnMore]: learnMoreTitle
        };
        return matcher[applicationAction];
    }
}
